/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-input-prefix-size: Specifies the component's prefix width.
* @prop --calcite-input-suffix-size: Specifies the component's suffix width.
*/
:host {
  display: block;
}

:host([scale=s]) input, :host([scale=s]) .prefix, :host([scale=s]) .suffix {
  block-size: 1.5rem;
  padding-inline: 0.5rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
}
:host([scale=s]) textarea {
  block-size: 1.5rem;
  min-block-size: 1.5rem;
}
:host([scale=s]) .number-button-wrapper, :host([scale=s]) .action-wrapper calcite-button, :host([scale=s]) .action-wrapper calcite-button button {
  block-size: 1.5rem;
}
:host([scale=s]) input[type=file] {
  block-size: 1.5rem;
}
:host([scale=s]) .clear-button {
  min-block-size: 1.5rem;
  min-inline-size: 1.5rem;
}
:host([scale=s]) textarea {
  block-size: auto;
  padding-block: 0.25rem;
  padding-inline: 0.5rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
}

:host([scale=m]) input, :host([scale=m]) .prefix, :host([scale=m]) .suffix {
  block-size: 2rem;
  padding-inline: 0.75rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}
:host([scale=m]) textarea {
  min-block-size: 2rem;
}
:host([scale=m]) .number-button-wrapper, :host([scale=m]) .action-wrapper calcite-button, :host([scale=m]) .action-wrapper calcite-button button {
  block-size: 2rem;
}
:host([scale=m]) input[type=file] {
  block-size: 2rem;
}
:host([scale=m]) .clear-button {
  min-block-size: 2rem;
  min-inline-size: 2rem;
}
:host([scale=m]) textarea {
  block-size: auto;
  padding-block: 0.5rem;
  padding-inline: 0.75rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}

:host([scale=l]) input, :host([scale=l]) .prefix, :host([scale=l]) .suffix {
  block-size: 2.75rem;
  padding-inline: 1rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
}
:host([scale=l]) textarea {
  min-block-size: 2.75rem;
}
:host([scale=l]) .number-button-wrapper, :host([scale=l]) .action-wrapper calcite-button, :host([scale=l]) .action-wrapper calcite-button button {
  block-size: 2.75rem;
}
:host([scale=l]) input[type=file] {
  block-size: 2.75rem;
}
:host([scale=l]) .clear-button {
  min-block-size: 2.75rem;
  min-inline-size: 2.75rem;
}
:host([scale=l]) textarea {
  block-size: auto;
  padding-block: 0.75rem;
  padding-inline: 1rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
}

:host([disabled]) textarea {
  resize: none;
}
:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

textarea,
input {
  transition: var(--calcite-animation-timing), block-size 0, outline-offset 0s;
  -webkit-appearance: none;
  position: relative;
  margin: 0px;
  box-sizing: border-box;
  display: flex;
  max-block-size: 100%;
  inline-size: 100%;
  max-inline-size: 100%;
  flex: 1 1 0%;
  border-radius: 0px;
  background-color: var(--calcite-color-foreground-1);
  font-family: inherit;
  font-weight: var(--calcite-font-weight-normal);
  color: var(--calcite-color-text-1);
}

input[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

input,
textarea {
  text-overflow: ellipsis;
  border-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-input);
  color: var(--calcite-color-text-1);
}
input:placeholder-shown,
textarea:placeholder-shown {
  text-overflow: ellipsis;
}

input:focus,
textarea:focus {
  border-color: var(--calcite-color-brand);
  color: var(--calcite-color-text-1);
}

input[readonly],
textarea[readonly] {
  background-color: var(--calcite-color-background);
  font-weight: var(--calcite-font-weight-medium);
}

input[readonly]:focus,
textarea[readonly]:focus {
  color: var(--calcite-color-text-1);
}

calcite-icon {
  color: var(--calcite-color-text-3);
}

textarea,
input {
  outline-color: transparent;
}

textarea:focus,
input:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

:host([status=invalid]) input, :host([status=invalid]) textarea {
  border-color: var(--calcite-color-status-danger);
}
:host([status=invalid]) input:focus, :host([status=invalid]) textarea:focus {
  outline: 2px solid var(--calcite-color-status-danger);
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

:host([scale=s]) .icon {
  inset-inline-start: 0.5rem;
}

:host([scale=m]) .icon {
  inset-inline-start: 0.75rem;
}

:host([scale=l]) .icon {
  inset-inline-start: 1rem;
}

:host([icon][scale=s]) input {
  padding-inline-start: 2rem;
}

:host([icon][scale=m]) input {
  padding-inline-start: 2.5rem;
}

:host([icon][scale=l]) input {
  padding-inline-start: 3.5rem;
}

.element-wrapper {
  position: relative;
  order: 3;
  display: inline-flex;
  flex: 1 1 0%;
  align-items: center;
}

.icon {
  pointer-events: none;
  position: absolute;
  display: block;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
}

.icon,
.resize-icon-wrapper {
  z-index: var(--calcite-z-index);
}

input[type=text]::-ms-clear,
input[type=text]::-ms-reveal {
  display: none;
  block-size: 0px;
  inline-size: 0px;
}

input[type=search]::-webkit-search-decoration,
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-results-button,
input[type=search]::-webkit-search-results-decoration,
input[type=date]::-webkit-clear-button,
input[type=time]::-webkit-clear-button {
  display: none;
}

.clear-button {
  pointer-events: initial;
  order: 4;
  margin: 0px;
  box-sizing: border-box;
  display: flex;
  min-block-size: 100%;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  border-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-input);
  background-color: var(--calcite-color-foreground-1);
  outline-color: transparent;
  border-inline-start-width: 0px;
}
.clear-button:hover {
  background-color: var(--calcite-color-foreground-2);
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
}
.clear-button:hover calcite-icon {
  color: var(--calcite-color-text-1);
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
}
.clear-button:active {
  background-color: var(--calcite-color-foreground-3);
}
.clear-button:active calcite-icon {
  color: var(--calcite-color-text-1);
}
.clear-button:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
.clear-button:disabled {
  opacity: var(--calcite-opacity-disabled);
}

.loader {
  inset-block-start: 1px;
  inset-inline: 1px;
  pointer-events: none;
  position: absolute;
  display: block;
}

.action-wrapper {
  order: 7;
  display: flex;
}

.prefix,
.suffix {
  box-sizing: border-box;
  display: flex;
  block-size: auto;
  min-block-size: 100%;
  -webkit-user-select: none;
          user-select: none;
  align-content: center;
  align-items: center;
  overflow-wrap: break-word;
  border-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-input);
  background-color: var(--calcite-color-background);
  font-weight: var(--calcite-font-weight-medium);
  line-height: 1;
  color: var(--calcite-color-text-2);
}

.prefix {
  order: 2;
  border-inline-end-width: 0px;
  inline-size: var(--calcite-input-prefix-size, auto);
}

.suffix {
  order: 5;
  border-inline-start-width: 0px;
  inline-size: var(--calcite-input-suffix-size, auto);
}

:host([alignment=start]) textarea, :host([alignment=start]) input {
  text-align: start;
}

:host([alignment=end]) textarea, :host([alignment=end]) input {
  text-align: end;
}

input[type=number] {
  -moz-appearance: textfield;
}
input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: textfield;
  margin: 0px;
}

.number-button-wrapper {
  pointer-events: none;
  order: 6;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
}

:host([number-button-type=vertical]) .wrapper {
  flex-direction: row;
  display: flex;
}

:host([number-button-type=vertical]) input,
:host([number-button-type=vertical]) textarea {
  order: 2;
}

:host([number-button-type=horizontal]) .calcite--rtl .number-button-item[data-adjustment=down] calcite-icon {
  transform: rotate(-90deg);
}
:host([number-button-type=horizontal]) .calcite--rtl .number-button-item[data-adjustment=up] calcite-icon {
  transform: rotate(-90deg);
}

.number-button-item.number-button-item--horizontal[data-adjustment=down], .number-button-item.number-button-item--horizontal[data-adjustment=up] {
  order: 1;
  max-block-size: 100%;
  min-block-size: 100%;
  align-self: stretch;
}
.number-button-item.number-button-item--horizontal[data-adjustment=down] calcite-icon, .number-button-item.number-button-item--horizontal[data-adjustment=up] calcite-icon {
  transform: rotate(90deg);
}

.number-button-item.number-button-item--horizontal[data-adjustment=down] {
  border-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-input);
  border-inline-end-width: 0px;
}
.number-button-item.number-button-item--horizontal[data-adjustment=down]:hover {
  background-color: var(--calcite-color-foreground-2);
}
.number-button-item.number-button-item--horizontal[data-adjustment=down]:hover calcite-icon {
  color: var(--calcite-color-text-1);
}

.number-button-item.number-button-item--horizontal[data-adjustment=up] {
  order: 5;
}
.number-button-item.number-button-item--horizontal[data-adjustment=up]:hover {
  background-color: var(--calcite-color-foreground-2);
}
.number-button-item.number-button-item--horizontal[data-adjustment=up]:hover calcite-icon {
  color: var(--calcite-color-text-1);
}

:host([number-button-type=vertical]) .number-button-item[data-adjustment=down]:hover {
  background-color: var(--calcite-color-foreground-2);
}
:host([number-button-type=vertical]) .number-button-item[data-adjustment=down]:hover calcite-icon {
  color: var(--calcite-color-text-1);
}

:host([number-button-type=vertical]) .number-button-item[data-adjustment=up]:hover {
  background-color: var(--calcite-color-foreground-2);
}
:host([number-button-type=vertical]) .number-button-item[data-adjustment=up]:hover calcite-icon {
  color: var(--calcite-color-text-1);
}

:host([number-button-type=vertical]) .number-button-item[data-adjustment=down] {
  border-block-start-width: 0px;
}

.number-button-item {
  max-block-size: 50%;
  min-block-size: 50%;
  pointer-events: initial;
  margin: 0px;
  box-sizing: border-box;
  display: flex;
  cursor: pointer;
  align-items: center;
  align-self: center;
  border-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-input);
  background-color: var(--calcite-color-foreground-1);
  padding-block: 0px;
  padding-inline: 0.5rem;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  border-inline-start-width: 0px;
}
.number-button-item calcite-icon {
  pointer-events: none;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
}
.number-button-item:focus {
  background-color: var(--calcite-color-foreground-2);
}
.number-button-item:focus calcite-icon {
  color: var(--calcite-color-text-1);
}
.number-button-item:active {
  background-color: var(--calcite-color-foreground-3);
}
.number-button-item:disabled {
  pointer-events: none;
}

.wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}

:input::-webkit-calendar-picker-indicator {
  display: none;
}

input[type=date]::-webkit-input-placeholder {
  visibility: hidden !important;
}

textarea::-webkit-resizer {
  position: absolute;
  inset-block-end: 0px;
  box-sizing: border-box;
  padding-block: 0px;
  padding-inline: 0.25rem;
  inset-inline-end: 0;
}

.resize-icon-wrapper {
  inset-block-end: 2px;
  inset-inline-end: 2px;
  pointer-events: none;
  position: absolute;
  block-size: 0.75rem;
  inline-size: 0.75rem;
  background-color: var(--calcite-color-foreground-1);
  color: var(--calcite-color-text-3);
}
.resize-icon-wrapper calcite-icon {
  inset-block-end: 0.25rem;
  inset-inline-end: 0.25rem;
  transform: rotate(-45deg);
}

.calcite--rtl .resize-icon-wrapper calcite-icon {
  transform: rotate(45deg);
}

:host([type=color]) input {
  padding: 0.25rem;
}

:host([type=file]) input {
  cursor: pointer;
  border-width: 1px;
  border-style: dashed;
  border-color: var(--calcite-color-border-input);
  background-color: var(--calcite-color-foreground-1);
  text-align: center;
}

:host([type=file][scale=s]) input {
  padding-block: 1px;
  padding-inline: 0.5rem;
}

:host([type=file][scale=m]) input {
  padding-block: 0.25rem;
  padding-inline: 0.75rem;
}

:host([type=file][scale=l]) input {
  padding-block: 0.5rem;
  padding-inline: 1rem;
}

:host(.no-bottom-border) input {
  border-block-end-width: 0px;
}

:host(.border-top-color-one) input {
  border-block-start-color: var(--calcite-color-border-1);
}

input.inline-child {
  background-color: transparent;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
}
input.inline-child .editing-enabled {
  background-color: inherit;
}
input.inline-child:not(.editing-enabled) {
  display: flex;
  cursor: pointer;
  text-overflow: ellipsis;
  border-color: transparent;
  padding-inline-start: 0;
}

.validation-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}

:host([scale=m]) .validation-container,
:host([scale=l]) .validation-container {
  padding-block-start: 0.5rem;
}

:host([scale=s]) .validation-container {
  padding-block-start: 0.25rem;
}

::slotted(input[slot=hidden-form-input]) {
  margin: 0 !important;
  opacity: 0 !important;
  outline: none !important;
  padding: 0 !important;
  position: absolute !important;
  inset: 0 !important;
  transform: none !important;
  -webkit-appearance: none !important;
  z-index: -1 !important;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}